export default "__VITE_ASSET__C6GpQkNI__"